var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
import { Flyout, FlyoutContent } from '../../../flyout';
import { NotificationBadge } from '../../Badge';
import NotificationList from '../../NotificationList';
import { FaRegBell } from 'react-icons/fa';
var BellIcon = styled(FaRegBell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 20px;\n  padding: 2px;\n  color: var(--topbar-icon-color);\n"], ["\n  font-size: 20px;\n  padding: 2px;\n  color: var(--topbar-icon-color);\n"])));
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 40px;\n  box-sizing: border-box;\n  all: unset;\n  position: relative;\n  margin-right: 8px;\n  padding: 6.75px 8px;\n  border-radius: 20px;\n  &:hover {\n    background-color: var(--topbar-hover-bg);\n  }\n"], ["\n  height: 40px;\n  box-sizing: border-box;\n  all: unset;\n  position: relative;\n  margin-right: 8px;\n  padding: 6.75px 8px;\n  border-radius: 20px;\n  &:hover {\n    background-color: var(--topbar-hover-bg);\n  }\n"])));
var NotificationsFlyout = function (props) {
    var _a, _b;
    var _c = React.useState(props.isFlyoutOpen), isFlyoutOpen = _c[0], setIsFlyoutOpen = _c[1];
    var unseenNotifications = props.notifications.unseen;
    React.useEffect(function () {
        if (!props.isFlyoutOpen) {
            setIsFlyoutOpen(props.isFlyoutOpen);
        }
    }, [isFlyoutOpen, props.isFlyoutOpen]);
    var toggleFlyout = function () {
        if (!isFlyoutOpen) {
            props.onOpenFlyout(props.name);
        }
        setIsFlyoutOpen(!isFlyoutOpen);
    };
    var CustomIcon = function (_a) {
        var children = _a.children;
        return React.cloneElement(props.notificationIcon, null, { children: children });
    };
    var UnreadNotificationsBadge = function () {
        return unseenNotifications > 0 && (_jsx(NotificationBadge, __assign({ "aria-label": "Unseen notifications" }, { children: unseenNotifications })));
    };
    return (_jsx(Flyout, __assign({ reference: props.notificationIcon ? (_jsx(CustomIcon, { children: _jsx(UnreadNotificationsBadge, {}) })) : (_jsxs(Button, __assign({ color: (_a = props.theme) === null || _a === void 0 ? void 0 : _a.topbarMenuIconColor, onClick: function () {
                if (props.onClick) {
                    props.onClick(toggleFlyout);
                }
                else {
                    toggleFlyout();
                }
            }, "aria-label": "Show notifications" }, { children: [_jsx(BellIcon, { color: (_b = props.theme) === null || _b === void 0 ? void 0 : _b.topbarMenuIconColor }), _jsx(UnreadNotificationsBadge, {})] }))), visible: isFlyoutOpen, trianglePosition: "calc(100% - 2.5rem)", close: function () { return setIsFlyoutOpen(false); }, shift: "calc(100% - 31rem)", width: "33.125rem", xxSmallStyles: "display: none", mediumStyles: "display: block" }, { children: _jsx(FlyoutContent, __assign({ style: {
                minHeight: '5rem'
            } }, { children: _jsx(NotificationList, { notifications: props.notifications, infiniteScrollUseWindow: false, copies: props.copies, markAllAsRead: props.markAllAsRead, loadMore: props.loadMore, onSingleNotificationClick: props.onSingleNotificationClick, onClickNotification: toggleFlyout }) })) })));
};
export default NotificationsFlyout;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map